<template>
  <button
    class="lv-toggle"
    :class="{ 'on': value }"
    @click="toggle"
    role="switch"
    :aria-checked="String(value)"
  >
    <span class="lv-thumb"></span>
  </button>
</template>

<script>
export default {
  name: 'LvToggle',
  props: {
    value: { type: Boolean, default: false }
  },
  methods: {
    toggle () {
      this.$emit('input', !this.value)
      this.$emit('change', !this.value)
    }
  }
}
</script>

<style scoped>
/* Track */
.lv-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  padding: 0;
  cursor: pointer;
  background: #d1d5db;
  transition: background 0.2s ease;
  outline: none;
  flex-shrink: 0;
  vertical-align: middle;
}
.lv-toggle.on {
  background: #413b94;
}
/* Thumb */
.lv-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}
/* 44 - 2 - 20 - 2 = 20px travel */
.lv-toggle.on .lv-thumb {
  transform: translateX(20px);
}
.lv-toggle:focus-visible {
  box-shadow: 0 0 0 3px rgba(65, 59, 148, 0.3);
}
</style>



// WEBPACK FOOTER //
// LvToggle.vue?d487778c